var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"key-message-container"},[_c('div',{staticClass:"key-message-wrapper"},[_c('div',{staticClass:"key-message-block"},[_c('h3',[_vm._v("HRモンスターなら")]),_vm._v(" "),_c('h2',[_vm._v("24時間365日業務をロボ社員におまかせ！")]),_vm._v(" "),_c('p',{staticClass:"sub-message"},[_vm._v("\n\t\t\t\tヒトにお願いする前に、まずロボに！ あなたのその業務、ロボが実行します！\n\t\t\t")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbd7f97","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LP/KeyMessage.vue
// module id = null
// module chunks = 